export default __webpack_public_path__ + "media/f02e24747506c076ad0b21c1476945ad.png";